
import crypto from "crypto-js";
export function generateSEKAndHash(token: any) {
  const iv = "df12da8shrism8sm";
  try {
    const key = crypto.lib.WordArray.random(32);
    let dataPayload = {};
    if (token === "" || token === null || token === undefined) {
      dataPayload = {
        // authorization: `Bearer `,
        // "x-portal": "admin",
        appKey: new Date().toISOString(),
      };
    } else {
      dataPayload = {
        // "x-portal": "admin",
        authorization: `Bearer ${token}`,
        appKey: new Date().toISOString(),
      };
    }
    
    console.log("APPKEY", dataPayload);
    let appkey = JSON.stringify(dataPayload);
    console.log("appkey :", appkey);
    const encrypted = crypto.AES.encrypt(appkey, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });
    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();
    return {
      hash: keyHash,
      sek: encryptedHex,
    };
  } catch (error) {
    console.error("", error);
  }
}

export function generateEncryptedKeyBody(body: any) {
  const iv = "df12da8shrism8sm";
  try {
    const key = crypto.lib.WordArray.random(32);
    let dataPayload = JSON.stringify(body);

    const encrypted = crypto.AES.encrypt(dataPayload, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });
    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();

    return {
      hash: keyHash,
      sek: encryptedHex,
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}
